import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { MatMenuTrigger } from '@angular/material/menu';
import { BehaviorSubject, Subject } from 'rxjs';
import { UserService } from '../../../user';

@Component({
  selector: 'members',
  templateUrl: './members.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'user',
})
export class MembersComponent implements OnInit, OnDestroy {
  membersList = new BehaviorSubject<Member[]>([]); // Use the specific Member type
  singleLabel = false;
  selectedMember: SelectedMemberType = getInitialSelectedMember();

  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(private _userService: UserService) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // this.membersList =this._userService.getMembers();
    this._userService.getMembers().subscribe((value: any) => {
      if (value && value.length == 1) {
        this.singleLabel = true;
        this._userService.setMember(value[0]);
      }
      this.membersList.next(value);
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  onSelection(option: any) {
    this.selectedMember = option;
    this._userService.setMember(option);
  }

  closeMenu(event: any) {
    if (this.trigger) this.trigger.closeMenu();
  }
}

interface Member {
  code: number | string;
  name: string;
}
type SelectedMemberType = Member | 'all' | null;
export function getInitialSelectedMember(): SelectedMemberType {
  const memberJson = localStorage.getItem('member');
  if (memberJson) {
    try {
      const parsedMember = JSON.parse(memberJson);
      return parsedMember === 'all' ? 'all' : (parsedMember as Member);
    } catch (e) {
      console.error('Error parsing member from localStorage', e);
      return 'all';
    }
  }
  return 'all';
}
